import { render, staticRenderFns } from "./allarea.vue?vue&type=template&id=78d7831f&scoped=true&"
import script from "./allarea.vue?vue&type=script&lang=js&"
export * from "./allarea.vue?vue&type=script&lang=js&"
import style0 from "./allarea.vue?vue&type=style&index=0&id=78d7831f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7831f",
  null
  
)

export default component.exports